import { request } from "components/hooks/useQuery";
import { PageSlug } from "types/base";
import { createSubscription } from "components/hooks/usePreview";
import { GetStaticPropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";
import { withAppLayout } from "components/core/withAppLayout";
import nextI18NextConfig from "./../../../../next-i18next.config";
import TextBlock, { ITextBlock } from "blocks/text/TextBlock";
import useTrans from "components/hooks/useTrans";
import { getAllFormsPages, getFormsPage } from "queries/Forms";
import { ICompaniesList } from "blocks/companies/CompaniesList";
import Container from "components/core/Container";
import Logo from "components/base/Logo";
import Link from "components/base/Link";
import Paragraph from "components/elements/Paragraph";
import Close from "assets/svg/icons/close.svg";
import { IFormBlock } from "blocks/form/Form";

export async function getStaticPaths({ locales }: any) {
    const { allFormPages } = await request({
        query: getAllFormsPages
    });

    const paths = allFormPages.map(({ slug }: any) => {
        return locales.map((locale: any) => ({
            params: { slug: slug }, locale: locale
        })).flat();
    }).flat();

    return {
        paths: paths,
        fallback: false
    };
}

export async function getStaticProps(context: GetStaticPropsContext) {
    const params = context.params as PageSlug;

    const query = {
        query: getFormsPage(params.slug, context.locale, context.locales),
        preview: context.preview,
        withAppData: true,
        locale: context.locale
    };

    let data = await createSubscription(context, query);

    if (!data?.initialData?.formPage) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            data: data,
            hideHeader: true,
            hideFooter: true,
            ...(await serverSideTranslations(context.locale, ['common'], nextI18NextConfig)),
        },
    };
}

export interface IFormPage {
    id: string,
    title: string,
    form: IFormBlock[],
    content: ITextBlock[],
    companies: ICompaniesList[],
    thankYou: ITextBlock[],
}

type Props = {
    formPage: IFormPage
};

function FormSectionThankYou(props: Props) {
    const { thankYou } = props.formPage;
    const { t } = useTrans();

    return (
        <div className={'w-screen top-0 h-screen lg:h-auto lg:mb-32 z-50 bg-white'}>
            <Container>
                <div className={'flex flex-row justify-between mt-20'}>
                    <Logo />
                    <div className={'flex flex-row gap-x-2'} >
                        <Paragraph size={'medium'} className={'my-auto'}>
                            {t('returnHome')}
                        </Paragraph>
                        <Link to={''} className={'my-auto cursor-pointer z-50'}>
                            <Close />
                        </Link>
                    </div>
                </div>
                
            </Container>
            <div className={'relative sm:inset-y-auto mt-10 sm:mt-20'}>
                {thankYou.map(ty => <TextBlock key={ty.id} {...ty} />)}
            </div>
        </div>
    );
}

export default withAppLayout(FormSectionThankYou);